"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import Image from "next/image";
import type { SolutionPageContent } from "@/app/servicos/modernizacao-de-sistemas-legados/content/content";
import Bg_Dots from "~/public/assets/backgrounds/bg-dots-2.png";
import ModernizationCard1 from "~/public/assets/modernization-systems/modernization-card-1.png";
import ModernizationCard2 from "~/public/assets/modernization-systems/modernization-card-2.png";
import ModernizationFlow from "~/public/assets/modernization-systems/modernization-flow.png";
import ModernizationFlowVertical from "~/public/assets/modernization-systems/modernization-flow-vertical.png";
import { useServiceCardsAnimation } from "../services-pages/use-service-cards-animation";
type SolutionsPageTemplateProps = {
  solutions: SolutionPageContent;
};
export default function ModernizationServicesSection(t0) {
  const $ = _c(23);
  const {
    solutions
  } = t0;
  const sectionRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      preset: "cascade"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useServiceCardsAnimation(sectionRef, t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={Bg_Dots} alt={"Imagem de fundo de pontos para decora\xE7\xE3o"} aria-hidden="true" className="absolute left-0 bottom-0 w-full h-auto max-w-[8%] 3xl:max-w-[9.8%] hidden lg:block" />;
    t3 = <Image src={Bg_Dots} alt={"Imagem de fundo de pontos para decora\xE7\xE3o"} aria-hidden="true" className="absolute right-0 bottom-0 w-full h-auto max-w-[8%] 3xl:max-w-[9.8%] hidden lg:block" />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="hidden md:inline-flex absolute -top-1.75 -left-1.75 h-3 w-3 border border-gray-300 bg-gray-1000" />;
    t5 = <span className="hidden md:inline-flex absolute -top-1.75 -right-1.75 h-3 w-3 border border-gray-300 bg-gray-1000" />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  const t6 = solutions.modernization?.tag;
  let t7;
  if ($[5] !== t6) {
    t7 = <p className="tag">{t6}</p>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = solutions.modernization?.title;
  let t9;
  if ($[7] !== t8) {
    t9 = <h2 className="title whitespace-pre-line">{t8}</h2>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t7 || $[10] !== t9) {
    t10 = <div data-service-card={true}>{t7}{t9}</div>;
    $[9] = t7;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = solutions.modernization?.description;
  let t12;
  if ($[12] !== t11) {
    t12 = <p data-service-card={true} className="mt-2 description leading-[180%]">{t11}</p>;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t10 || $[15] !== t12) {
    t13 = <div className="flex flex-col items-center text-center max-w-180 mx-auto">{t10}{t12}</div>;
    $[14] = t10;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  let t15;
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Image src={ModernizationCard1} alt={"Imagem de um cart\xE3o com um sistema modernizado"} aria-hidden="true" className="w-full h-auto lg:max-w-[44%]" width={1000} height={1000} />;
    t15 = <Image src={ModernizationFlow} alt={"Imagem de um cart\xE3o com um sistema modernizado"} aria-hidden="true" className="hidden lg:block w-full h-auto max-w-66 absolute top-[35%] left-1/2 -translate-x-1/2 -translate-y-1/2" width={1000} height={1000} />;
    t16 = <Image src={ModernizationFlowVertical} alt={"Imagem de um cart\xE3o com um sistema modernizado"} aria-hidden="true" className="block lg:hidden w-full h-auto max-w-70 md:max-w-90 absolute top-[50%] left-1/2 -translate-x-1/2 -translate-y-1/2" width={1000} height={1000} />;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t14 = $[17];
    t15 = $[18];
    t16 = $[19];
  }
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className={"mt-16 relative flex items-center gap-10 justify-between\r\n\t\t\t\t\tmax-lg:flex-col max-lg:gap-50"}>{t14}{t15}{t16}<div className="w-full h-auto lg:max-w-[44%] relative"><Image src={ModernizationCard2} alt={"Imagem de um cart\xE3o com um sistema modernizado"} aria-hidden="true" className="w-full h-auto" width={1000} height={1000} /><p className="max-sm:text-[10px] text-xs xl:text-sm text-white/60 leading-[160%] absolute bottom-[14%] md:bottom-[20%] lg:bottom-[16%] xl:bottom-[20%] left-[15%] right-[10%] w-full max-w-fit">O resultado é uma plataforma mais moderna, preparada para novas integrações, escalabilidade e evolução contínua.</p></div></div>;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t13) {
    t18 = <section ref={sectionRef} className="relative text-white ">{t2}{t3}<div className="md:container-padding relative"><div data-service-cards-animation-trigger={true} className="container relative md:border-x md:border-gray-300 px-6 lg:px-18 3xl:px-24! pt-24 pb-32">{t4}{t5}{t13}{t17}</div></div></section>;
    $[21] = t13;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  return t18;
}